import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/404.png'


const _hoisted_1 = {
  key: 0,
  class: "timeline-container"
}
const _hoisted_2 = { class: "lineleft" }
const _hoisted_3 = { class: "entry-list" }
const _hoisted_4 = { class: "flow-header" }
const _hoisted_5 = { class: "user" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "content-wrapper" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = ["href", "title"]
const _hoisted_12 = { class: "title" }
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "content" }
const _hoisted_15 = {
  key: 0,
  class: "img"
}
const _hoisted_16 = { class: "user-image" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "sidebar-container" }
const _hoisted_21 = { class: "useritem" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  class: "info-box",
  style: {"visibility":"visible"}
}
const _hoisted_24 = { class: "username" }
const _hoisted_25 = {
  class: "name",
  style: {"max-width":"128px"}
}
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "oneself" }
const _hoisted_28 = { class: "aboutme" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["href"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "empty-list"
}

import { ref, onMounted, reactive } from "vue";
import type { Ref } from "vue";

import MainHeader from "@/components/main-header.vue";
import { ElMessage } from "element-plus";
import axiosInstance from "@/utils/axiosInstance";
import { format } from "date-fns";
import { useRouter } from "vue-router";

import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";

interface UserInfo {
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
}

interface Article {
  article_id: string;
  title: string;
  brief_content: string;
  cover_image: string;
  uuid: string;
}

//时间格式化

export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {

const SSRData = ref({
  title: "",
  description: "",
  keywords: "",
});

const router = useRouter();

//页面状态
const state = reactive({
  isempty: ref(true),
});

//接口
const userInfo = ref<UserInfo>({
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: 0,
  userlevel: 0,
  phone_verified: 0,
  wechat_verified: 0,
  weibo_verified: 0,
  github_verified: 0,
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: 0,
  following: 0,
  created_at: "",
});

//获取用户简介
const fetchUserInfo = async (userId: string) => {
  try {
    await axiosInstance
      .get("/api/HomeUser/profile_id", {
        params: { uuid: userId },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;

          //SEO 内容
          SSRData.value.title =
            userInfo.value.uname + " 的个人主页 - 动态 - " + WebSite_Name;
          SSRData.value.description =
            userInfo.value.job_title +
            " @" +
            userInfo.value.ucompany +
            " " +
            userInfo.value.description;
          SSRData.value.keywords = userInfo.value.description;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = "找不到页面";
          SSRData.value.description = "";
          SSRData.value.keywords = "";
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

//定义数据和接口类型
const formatDate = (date: string | Date) => {
  return format(new Date(date), "yyyy-MM-dd");
};

const articles = ref<Article[]>([]);
const currentPage = ref(1);
const totalPages: Ref<number> = ref(0);
const loading: Ref<boolean> = ref(false);
const userID = ref("");
const hasMore = ref(true); // 是否还有更多数据

const fetchArticles = async (page: number) => {
  try {
    loading.value = true;
    const response = await axiosInstance.get(
      "/api/HomeArticle/recommend_userinfo_feed",
      {
        params: { page: page, user_id: userID.value },
      }
    );
    var result = response.data;

    if (page === 1) {
      articles.value = result.data.data;
    } else {
      articles.value.push(...result.data.data);
    }
    currentPage.value = result.data.page;
    totalPages.value = result.data.pageCount;
    hasMore.value = currentPage.value <= result.data.pageCount;
  } catch (error) {
    console.error("请求失败:", error);
  } finally {
    loading.value = false;
  }
};

const loadMore = () => {
  if (!hasMore.value || loading.value) return;
  fetchArticles(currentPage.value + 1);
};

onMounted(async () => {
  //获取文章ID 参数
  userID.value = router.currentRoute.value.params.userID as string;
  fetchUserInfo(userID.value);
  fetchArticles(1);
});

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MainHeader),
    (state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_3, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "nav-tab" }, [
                  _createElementVNode("div", { class: "tabItem active" }, "文章")
                ], -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (articleitem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "infor-list",
                    key: articleitem.article_id
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("img", {
                          src: articleitem.avatar_url,
                          class: "avatar"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(articleitem.author), 1),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(formatDate(articleitem.created_at)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("a", {
                            href: `/post/${articleitem.article_id}`,
                            title: articleitem.title,
                            class: "titlelink",
                            target: "_blank"
                          }, [
                            _createElementVNode("h1", _hoisted_12, _toDisplayString(articleitem.title), 1)
                          ], 8, _hoisted_11),
                          _createElementVNode("a", {
                            href: `/post/${articleitem.article_id}`,
                            class: "titlelink",
                            target: "_blank"
                          }, [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(articleitem.brief_content), 1)
                          ], 8, _hoisted_13)
                        ])
                      ]),
                      (articleitem.cover_image)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("a", {
                                href: `/post/${articleitem.article_id}`,
                                target: "_blank"
                              }, [
                                _createElementVNode("img", {
                                  class: "image-loct",
                                  src: articleitem.cover_image,
                                  width: "192",
                                  height: "128"
                                }, null, 8, _hoisted_18)
                              ], 8, _hoisted_17)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128)),
                (hasMore.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "load-more",
                      onClick: loadMore,
                      style: {"text-align":"center","padding-top":"50px"}
                    }, _toDisplayString(loading.value ? "加载中..." : "加载更多"), 1))
                  : _createCommentVNode("", true),
                (!hasMore.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[0] || (_cache[0] = [
                      _createElementVNode("div", { style: {"text-align":"center","padding-top":"50px"} }, "暂无数据", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: userInfo.value.avatar_url,
                  class: "avatar"
                }, null, 8, _hoisted_22),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(userInfo.value.uname), 1)
                  ]),
                  _createElementVNode("div", {
                    class: "position",
                    title: userInfo.value.job_title + ' @' + userInfo.value.ucompany
                  }, _toDisplayString(userInfo.value.job_title) + " @" + _toDisplayString(userInfo.value.ucompany), 9, _hoisted_26)
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("p", null, _toDisplayString(userInfo.value.description), 1),
                _createElementVNode("div", _hoisted_28, [
                  (userInfo.value.blog_address)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _cache[2] || (_cache[2] = _createTextVNode(" - 个人主页：")),
                        _createElementVNode("a", {
                          href: userInfo.value.blog_address,
                          target: "_blank"
                        }, _toDisplayString(userInfo.value.blog_address), 9, _hoisted_30)
                      ]))
                    : _createCommentVNode("", true),
                  (userInfo.value.github_html_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _cache[3] || (_cache[3] = _createTextVNode(" - GitHub：")),
                        _createElementVNode("a", {
                          href: userInfo.value.github_html_url,
                          target: "_blank"
                        }, _toDisplayString(userInfo.value.github_html_url), 9, _hoisted_32)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!state.isempty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, _cache[4] || (_cache[4] = [
          _createElementVNode("div", { class: "null-infor-list" }, [
            _createElementVNode("div", { class: "content-flag" }, [
              _createElementVNode("div", { class: "common-empty" }, [
                _createElementVNode("img", { src: _imports_0 })
              ])
            ])
          ], -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}
}

})